export default class ApplicationModel {
    static $inject = ['config'];

    constructor(config = {}) {
        this.shortName = config.shortName;
        this.name = config.name;
        this.description = config.description;
        this.imageUri = config.imageUri;
        this.messagingHubCommandWithDelegation = config.messagingHubCommandWithDelegation;
    }
}
